import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { FeatureFlag } from '../models/feature-flag.model';
import { loadAllFeatureFlags } from './feature-flag.actions';

/**
 * @ngrx/entity provides a predefined interface for handling
 * a structured dictionary of records. This interface
 * includes an array of ids, and a dictionary of the provided
 * model type by id. This interface can be extended to include
 * any additional interface properties.
 */
export type FeatureFlagsState = EntityState<FeatureFlag>;

/**
 * createEntityAdapter creates an object of many helper
 * functions for single or multiple operations
 * against the dictionary of records. The configuration
 * object takes a record id selector function and
 * a sortComparer option which is set to a compare
 * function if the records are to be sorted.
 */
const adapter: EntityAdapter<FeatureFlag> = createEntityAdapter<FeatureFlag>({
  selectId: (featureFlag: FeatureFlag) => featureFlag.id,
  sortComparer: false
});

/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
const initialState: FeatureFlagsState = adapter.getInitialState();

export const featureFlagReducer = createReducer(
  initialState,

  on(loadAllFeatureFlags, (state, request) => adapter.addMany(request.payload, state))
);
